import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FeatureFlagService } from 'app/core/services/feature-flag.service';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { TaskRolesComponent } from './task-roles.component';
import { TaskRolesListComponent } from './task-roles-list/task-roles-list.component';
import { TaskRolesRoutingModule } from './task-roles-routing.module';
import { TaskRolesResolver } from './task-roles.resolvers';
import { TaskRolesAddComponent } from './task-roles-add/task-roles-add.component';
import { DirectivesModule } from 'app/shared/directives/directives.module';

@NgModule({
  declarations: [TaskRolesComponent, TaskRolesListComponent, TaskRolesAddComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TaskRolesRoutingModule,
    MatProgressBarModule,
    MatListModule,
    PipesModule,
    MatTableModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatTabsModule,
    MatInputModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    DirectivesModule,
  ],
  providers: [TaskRolesResolver, FeatureFlagService],
})
export class TaskRolesModule {}
